// src/stone/icons/Heart.tsx
import { jsx } from "react/jsx-runtime";
var Heart = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "M14.292 1.556c.77-.365 1.6-.556 2.444-.556s1.674.19 2.443.556a6.3 6.3 0 0 1 2.033 1.555 7.2 7.2 0 0 1 1.328 2.275c.304.843.46 1.743.46 2.65s-.156 1.806-.46 2.649a7.2 7.2 0 0 1-1.329 2.275l-8.458 9.697a1 1 0 0 1-1.507 0L2.788 12.96C1.631 11.633 1 9.86 1 8.035s.631-3.598 1.788-4.924C3.948 1.78 5.555 1 7.264 1c1.708 0 3.314.779 4.475 2.11l.26.299.261-.299a6.3 6.3 0 0 1 2.032-1.555M16.736 3c-.54 0-1.078.122-1.585.363-.509.241-.98.6-1.383 1.062l-1.015 1.163a1 1 0 0 1-1.507 0l-1.014-1.163c-.814-.932-1.885-1.424-2.968-1.424-1.084 0-2.155.492-2.969 1.424C3.478 5.362 3 6.66 3 8.035c0 1.377.478 2.673 1.295 3.61L12 20.48l7.704-8.834c.404-.462.73-1.019.955-1.64S21 8.715 21 8.035c0-.678-.117-1.348-.341-1.97a5.2 5.2 0 0 0-.955-1.64 4.3 4.3 0 0 0-1.383-1.062A3.7 3.7 0 0 0 16.736 3" })
  }
);
var Heart_default = Heart;

export {
  Heart,
  Heart_default
};
